import React from "react";

const LoggedPageContext = React.createContext();

export { LoggedPageContext };